import React, { Component } from 'react'
import apiService from '../../services/ApiService'
import Select from 'react-select'

class EntityStatusCombo extends Component {
    constructor() {
        super()
        this.state = {
            entityStatusComboList: "",
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getEntyStatusComboList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getEntyStatusComboList = () => {
        apiService.getEntyStatusComboList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        entityStatusComboList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}

        
             list = Object.keys(this.state.entityStatusComboList).map((value,index) => {            
                    return {
                        label : this.state.entityStatusComboList[value],
                        value : this.state.entityStatusComboList[value]
                    }
            })
           

        
        list.sort((a,b) => a.label.localeCompare(b.label));


        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Type"
                options={list}
                onChange={(e) => { (e) ? this.props.entityStatusComboChange(e) : this.props.entityStatusComboChange([])}}
                />
            </div>
        )
    }
}
export default EntityStatusCombo


// WEBPACK FOOTER //
// ./src/common/DropDowns/EntityStatusCombo.js